export default function getResource(label, vars = []) {
    const resources = {
        autoReplenishTitle: `Réapprovisionnement automatique (${vars[0]})`,
        changeMethod: 'Changer la méthode',
        qtyUpdateError: 'Nous n’avons pas pu mettre à jour la quantité. Veuillez essayer de nouveau.',
        retry: 'Réessayer'
    };

    return resources[label];
}
